import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Badge, Button, Card, Col, Row, Spinner } from 'react-bootstrap';
import { api } from '../../lib/api';
import { useToast } from '../../context/ToastContext';
import { useAuth } from '../../context/AuthContext';

// Campo -> rótulo dos dados de interesse capturados no lead (site/portais)
// — só leitura, lead não tem tela de edição (mesmo comportamento do
// original, LeadsController não tinha update).
const CAMPOS_INTERESSE = [
  ['l1_tipoimovel', 'Tipo de imóvel'],
  ['l1_tituloimovel', 'Imóvel de interesse'],
  ['l1_valorimovel', 'Valor'],
  ['l1_valorlocacao', 'Valor de locação'],
  ['l1_bairroimovel', 'Bairro'],
  ['l1_cidade', 'Cidade'],
  ['l1_estado', 'Estado'],
  ['l1_qtddormitorios', 'Dormitórios'],
  ['l1_qtdgaragens', 'Garagens'],
  ['l1_financiamento', 'Financiamento'],
];

export default function PaginaLead() {
  const { publicId } = useParams();
  const { usuario } = useAuth();
  const toast = useToast();
  const [lead, setLead] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [efetivando, setEfetivando] = useState(false);
  const [erro, setErro] = useState(false);

  useEffect(() => {
    api
      .get(`/leads/${publicId}`)
      .then((r) => setLead(r.data))
      .catch((err) => {
        setErro(true);
        toast.erro(err.message || 'Não foi possível carregar o lead');
      })
      .finally(() => setCarregando(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [publicId]);

  async function efetivar() {
    setEfetivando(true);
    try {
      await api.post(`/leads/${publicId}/efetivar`);
      setLead((l) => ({ ...l, l1_integrado: 'integrado' }));
      toast.sucesso('Cliente criado com sucesso a partir deste lead.');
    } catch (err) {
      toast.erro(err.message || 'Não foi possível efetivar o lead');
    } finally {
      setEfetivando(false);
    }
  }

  if (carregando) return <Spinner animation="border" />;
  if (erro || !lead) return null;

  const jaIntegrado = lead.l1_integrado === 'integrado';

  return (
    <>
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4">
        <h1 className="h4 mb-0">{lead.l1_nome || '(sem nome)'}</h1>
        {jaIntegrado ? (
          <Badge bg="success">Já integrado a um cliente</Badge>
        ) : (
          usuario.permissoes?.leads_efetivar === true && (
            <Button variant="primary" onClick={efetivar} disabled={efetivando}>
              {efetivando ? <Spinner animation="border" size="sm" /> : 'Efetivar em cliente'}
            </Button>
          )
        )}
      </div>

      <Card className="mb-3">
        <Card.Body>
          <Card.Title className="h6">Contato</Card.Title>
          <Row>
            <Col md={4}>
              <strong>Telefone:</strong> {lead.l1_telefone || '—'}
            </Col>
            <Col md={4}>
              <strong>E-mail:</strong> {lead.l1_email || '—'}
            </Col>
            <Col md={4}>
              <strong>Origem:</strong> {lead.l1_midia || lead.l1_referencia || '—'}
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card>
        <Card.Body>
          <Card.Title className="h6">Interesse</Card.Title>
          <Row>
            {CAMPOS_INTERESSE.map(([campo, rotulo]) => (
              <Col md={4} key={campo} className="mb-2">
                <strong>{rotulo}:</strong> {lead[campo] || '—'}
              </Col>
            ))}
          </Row>
        </Card.Body>
      </Card>
    </>
  );
}
